import React, { useEffect } from 'react';
import NudosKamClient from '../../../../../../components/NudosComponents/NudosKamClient/NudosKamClient';
import { IKamClient } from '../../../../../../types/kamClient.types';
import alertMessage from '../../../../../../utils/alertMessage';
import errorMessage from '../../../../../../utils/errorMessage';
import { assignKam } from '../../../../../../services/kamServices';

const KamClient = ({ organizationId }: { organizationId: string }) => {
  const [selectedKamClient, setSelectedKamClient] = React.useState<IKamClient | null | undefined>(null);
  const [loading, setLoading] = React.useState<boolean>(false);
  const handleKamClientChange = (newValue?: IKamClient | null) => {
    setSelectedKamClient(newValue);
  };

  const sendKamClientSelected = async () => {
    if (!selectedKamClient || !selectedKamClient.id) return;
    setLoading(true);
    try {
      const transformIdOrganization = parseInt(organizationId);
      await assignKam({ organizationId: transformIdOrganization, kamUserId: selectedKamClient.id });
      alertMessage('Seleccionaste el KAM con éxito');
    } catch (error) {
      errorMessage();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!!selectedKamClient) {
      sendKamClientSelected();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedKamClient]);

  return (
    <>
      <div className="accountTitle">KAM del cliente</div>
      <NudosKamClient
        organizationId={organizationId}
        currentValue={selectedKamClient}
        updateCurrentValueCallback={handleKamClientChange}
        componentSize="large"
        isDeactivated={loading}
        loadingKamClient={loading}
      />
    </>
  );
};

export default KamClient;
